import React, { useState, useEffect } from "react";
import moment from "moment/moment";

// components
import PaginationHelper from "../../components/PaginationHelper";
import AnimationLoading from "../../components/Animationloading";
import EmptyComponent from "../../components/EmptyComponent";

// apollo-client
import { GET_PRODUCT_HISTORY } from "../../apollo/product/query";
import { useLazyQuery } from "@apollo/client";

// Icons
import SearchIcon from "@mui/icons-material/Search";

// Bootrap
import { Form, Row, InputGroup, Col, Table } from "react-bootstrap";
import BreadCrumbComponent from "../../components/BreadCrumbComponent";

export default function HistoryProduct() {
  const dateNow = new Date().toISOString().slice(0, 10);
  const [productHistory, setProductHistory] = useState();
  const [productHistorytotal, setProductHistoryTotal] = useState();
  const [currentStartDate, setCurrentStartDate] = useState("2023-09-01");
  const [currentEndDate, setCurrentEndDate] = useState(dateNow);
  const [searchText, setSearchText] = useState("");
  const { _limit, _skip, Pagination_helper } = PaginationHelper();

  // ============== > UseLazyQuery And UseMutaion <==============

  const [getproducthistory, { data: getproducthistoryData, loading }] =
    useLazyQuery(GET_PRODUCT_HISTORY, { fetchPolicy: "cache-and-network" });

  // ============== > useEffect <==============

  useEffect(() => {
    if (getproducthistoryData) {
      setProductHistory(getproducthistoryData?.productHistories?.data);
      setProductHistoryTotal(getproducthistoryData?.productHistories?.total);
    }
  }, [getproducthistoryData]);

  console.log("result: ", getproducthistoryData);

  useEffect(() => {
    _filter();
  }, []);

  useEffect(() => {
    _filter();
  }, [searchText, currentStartDate, currentEndDate, _skip]);

  // ============== > fuctions <==============

  const _filter = async () => {
    try {
      let shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;

      let _where = {
        shop: shopId,
        isDeleted: false,
      };
      // TODO: check if search text is not empty
      if (searchText !== "") {
        _where = {
          ..._where,
          name: searchText,
          barCode: searchText,
        };
      }
      //check if filter date is set
      if (currentStartDate && currentEndDate) {
        _where = {
          ..._where,
          createdAt_gte: new Date(
            moment(moment(currentStartDate).format("YYYY-MM-DD")).toISOString()
          ),
          createdAt_lt: new Date(
            moment(moment(currentEndDate).add(1, "days")).format("YYYY-MM-DD")
          ).toISOString(),
        };
      }

      // TODO: Get all order groups
      getproducthistory({
        variables: {
          where: _where,
          skip: (_skip - 1) * _limit,
          limit: 50,
          orderBy: "createdAt_DESC",
        },
      });
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  console.log("productHistory====55555>", productHistory);

  const handleChangeStartDate = (e) => {
    setCurrentStartDate(e?.target?.value);
  };

  const handleChangeEndDate = (e) => {
    setCurrentEndDate(e?.target?.value);
  };

  return (
    <React.Fragment>
      <div className="sale-history-mains">
        <BreadCrumbComponent
          // goback={() => history.goBack()}
          // txtFirst="ປະຫວັດການຂາຍ"
          txtSecond={`ປະຫວັດການແກ້ໄຂສະຕ໋ອກ`}
        />

        <div style={{ padding: "1em 2em" }}>
          <h4>
            <b>ຂໍ້ມູນປະຫວັດການແກ້ໄຂ</b>
          </h4>
          <p>
            ສິນຄ້າທີ່ຖຶກແກ້ໄຂຜ່ານມາທັງໝົດໃນຮ້ານຂອງທ່ານ.
          </p>
        </div>

        <div style={{ padding: "0 2em" }}>
          <Row>
            <Col className="col-6">
                <Form.Label>ຄົ້ນຫາ</Form.Label>
              <InputGroup>
                <InputGroup.Text
                  style={{
                    backgroundColor: "#fff", 
                  }}>
                  <SearchIcon sx={{ color: "#6B7280" }} />
                </InputGroup.Text>
                <Form.Control
                  placeholder="ຊື່ສິນຄ້າ..."
                  aria-label="Recipient's username"
                  aria-describedby="basic-addon2"
                  onChange={(e) => {
                    setSearchText(e.target.value);
                  }}
                  value={searchText}
                  style={{
                    borderLeft: "none",
                  }}
                />
              </InputGroup>
            </Col>
            <Col className="col-3">
              <Form.Label>ຈາກວັນທີ</Form.Label>
              <Form.Control
                type="date"
                value={currentStartDate}
                onChange={(e) => handleChangeStartDate(e)}
              />
            </Col>
            <Col className="col-3">
              <Form.Label>ຫາວັນທີ</Form.Label>
              <Form.Control
                type="date"
                value={currentEndDate}
                onChange={(e) => handleChangeEndDate(e)}
              />
            </Col>
          </Row>
        </div>

        <div style={{ padding:'1em 2em' }}>
          {loading && !getproducthistoryData?.productHistories ? (
            <AnimationLoading />
          ) : (
            <>
              {productHistory?.length > 0 ? (
                <Table
                  hover
                  style={{
                    borderCollapse: "collapse",
                    width: "100% ",
                    background:'#fff',marginTop:'-.5em'
                  }}>
                  <thead
                    style={{
                      background:
                        "#1F3A60",
                      borderRadius: " 8px 8px 0px 0px",
                      color: "#FFFFFF",
                    }}>
                    <tr>
                      {/* <th>#</th> */}
                      <th>ລ/ດ</th>
                      <th>ລະຫັດບາໂຄດ</th>
                      <th>ຊື່ລາຍການສິນຄ້າ</th>
                      <th>ຈຳນວນ</th>
                      <th>ຫົວໜ່ວຍ</th>
                      <th>ວັນທີ່ເດືອນປີ</th>
                      <th>ສະກຸນເງີນ</th>
                    </tr>
                  </thead>
                  <tbody>
                    {productHistory?.map((product, index) => (
                      <tr>
                        <td>{index + 1 + _limit * (_skip - 1)}</td>
                        <td>{product?.barCode}</td>
                        <td>{product?.name}</td>
                        <td>{product?.amount}</td>
                        <td>{product?.unit?.name}</td>
                        <td>
                          {moment(product?.updatedAt).format("DD/MM/YYYY")}
                        </td>
                        <td>
                          {product?.currency === "BAHT"
                            ? "THB"
                            : product?.currency}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              ) : (
                <div>
                  {productHistory?.length <= 0 && (
                    <div
                      style={{
                        fontSize: "24px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "#6B7280",
                        fontWeight: "400",
                      }}>
                      <EmptyComponent />
                      <p>ຍັງບໍ່ມີປະຫວັດການເເກ້ໄຂສະຕອັກ !!!</p>
                    </div>
                  )}
                </div>
              )}
            </>
          )}
        </div>
        {productHistorytotal > 0 ? (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding:'1em 2em'
            }}>
            {productHistorytotal && (
              <div className="show">
                ກຳລັງສະແດງ {50 * _skip - 49}-
                {50 * _skip > productHistorytotal
                  ? productHistorytotal
                  : 50 * _skip}{" "}
                ຈາກ {productHistorytotal}
              </div>
            )}
            <div>{Pagination_helper(productHistorytotal, "", ``)}</div>
          </div>
        ) : (
          ""
        )}
      </div>
    </React.Fragment>
  );
}
